import {createFileRoute, redirect} from '@tanstack/react-router';
import {Navbar} from '@/components/ui/navbar';
import {adminBlogPostQuery} from '@/queries/blog';
import {BlogPostForm} from '@/components/adminBlog/blogPostForm';

export const Route = createFileRoute('/admin/blog-edit/$id')({
  component: AdminBlogEditPage,
  beforeLoad: ({context, location}) => {
    if (!context.profile) {
      throw redirect({
        to: '/login',
        search: {redirect: location.href},
      });
    }
    if (context.profile.level !== 'superadmin') {
      throw redirect({to: '/'});
    }
  },
  loader: async ({params}) => {
    const post = await adminBlogPostQuery({data: params.id});
    return {post};
  },
});

/** Standalone full-width page for editing a blog post. */
function AdminBlogEditPage() {
  const {post} = Route.useLoaderData();

  return (
    <div className="h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <div className="flex-1 min-h-0 flex flex-col pt-6 px-6">
        <BlogPostForm post={post} />
      </div>
    </div>
  );
}
